import cookie from 'js-cookie'
import axios from '../utils/AxiosInstance'

// const accessToken = localStorage.getItem('access_token')
const accessToken = cookie.get('access_token')

export default {
  // namespaced: true,
  state: {
    token: accessToken
  },
  mutations: {
    AUTH_SET_TOKEN (store, val) {
      store.token = val
      if (val) {
        // localStorage.setItem('access_token', val)
        cookie.set('access_token', val, { expires: 60 }) //, domain: window.location.hostname
      } else {
        cookie.remove('access_token')
      }
    }
  },
  getters: {
    authToken: (store) => {
      return store.token
    }
  },
  actions: {
    /*
    token
    */
    authLogin ({commit, dispatch}, val) {
      return axios
      .post(`/auth`, val)
      .then((response) => {
        commit('AUTH_SET_TOKEN', response.data.token)
        return response.data
      })
    },
    /*
    authLoginSSO
    */
    authLoginSSO ({commit, dispatch}, val) {
      return axios
      .post(`/auth/sso`, val)
      .then((response) => {
        return response.data
      })
    },
    /*
    authEmailValidationToken
    */
    authEmailValidationToken ({commit, dispatch}, val) {
      return axios
      .post(`/auth/email-validation-token`, val)
      .then((response) => {
        return response.data
      })
    },
    /*
    authLoginDefinitiveToken
    */
    authLoginDefinitiveToken ({commit, dispatch}, val) {
      return axios
      .post(`/auth/definitive-token`, val)
      .then((response) => {
        commit('AUTH_SET_TOKEN', response.data.token)
        return response.data
      })
    },
    /*
    authLoginErrorData
    */
    authLoginErrorData ({commit, dispatch}, val) {
      return axios
      .post(`/auth/oauth/error-data`, val)
      .then((response) => {
        commit('AUTH_SET_TOKEN', response.data.token)
        return response.data
      })
    },
    /*
    authSetToken
    */
    authSetToken ({commit, dispatch}, token) {
      commit('AUTH_SET_TOKEN', token)
      return true
    },
    /*
    authPasswordRedefinedNotification
    */
    authPasswordRedefinedNotification ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/auth/password-redefined-notification`, data)

      .then((response) => {
        return response.data
      })
    },
    /*
    authPasswordRedefined
    */
    authPasswordRedefined ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/auth/password-redefined/${data.token}`, data)
      .then((response) => {
        return response.data
      })
    },
    /*
    authAcceptNewEmail
    */
    authAcceptNewEmail ({commit, dispatch, getters, state}, token) {
      return axios
      .post(`/auth/accept-new-email/${token}`, {})
      .then((response) => {
        return response.data
      })
    },
    /*
    authNewMemberTemplate
    */
    authNewMemberTemplate ({commit, dispatch, getters, state}, token) {
      return axios.get(`/auth/new-member/${token}/template`, {}).then((response) => {
        return response.data
      })
    },
    /*
    authNewMember
    */
    authNewMember ({commit, dispatch, getters, state}, data) {
      return axios.post(`/auth/new-member/${data.token}`, data).then((response) => {
        return response.data
      })
    },
    authLogout ({commit, dispatch}) {
      return axios
      .post(`/auth/logout`, {})
      .then((response) => {
        commit('AUTH_SET_TOKEN', null)
        commit('SET_ME', null)
        commit('SET_PROFILE', null)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Auth.js